import * as Tone from 'tone';
// import { AudioContext } from 'standardized-audio-context';
import StartAudioContext from 'startaudiocontext';

//try https://github.com/Tonejs/Tone.js/issues/224
export default class Sound
{
    // constructor()
    // {
    //     // const audioContext = new AudioContext();
    //     // Tone.setContext(audioContext);
    // }

    start(domElem)
    {
        StartAudioContext(Tone.context, domElem);
        console.log('start audiocontext');
    }

    setup()
    {
        let gain = new Tone.Volume(0).toMaster();
        gain.set('volume', -15);
    }

    createSinths()
    {
        let chorus = new Tone.Chorus(2.5, 100, 0.5).toMaster();
        let delay = new Tone.PingPongDelay("4n", 0.5).connect(chorus); //.toMaster();

        this.polySynth = new Tone.PolySynth().connect(delay);
        this.polySynth.toMaster();
        this.polySynth.vibratoAmount = 0.1;

        this.duoSynth = new Tone.DuoSynth().connect(delay);
        this.duoSynth.toMaster();
    };

    playNote(synth)
    {
        let notes = ['A1', 'A2', 'A3', 'A4', 'C1', 'C2', 'C3', 'C4', 'B1', 'B2', 'B3', 'B4', 'D1', 'D2', 'D3', 'D4'];
        synth.triggerAttackRelease((0, randomElement(notes)), "16n");
    };

    playOnTrigger()
    {
        //https://github.com/Tonejs/Tone.js/issues/341
        if (Tone.context.state !== 'running') 
        {
            Tone.context.resume();
        }
        this.playNote(this.duoSynth);
        this.playNote(this.polySynth);
    };

    update() 
    {
        if(Tone.context.state && Tone.context.state === "suspended") 
        {
          Tone.context.resume().then(function () 
          {
                console.log("AudioContext resumed!");
                // fire your callback here
          });
        }
    };

    stop()
    {
        this.polySynth.dispose();
        this.duoSynth.dispose();
        // Tone.context.close();
        console.log('stop audiocontext');
    }
};  

/**
   * returns a random element from an array or object
   * @param  {Array|Object} obj
   * @return {object}
   */

function randomElement(obj) 
{
    if (Array.isArray(obj)) 
    {
        return obj[Math.floor(Math.random() * obj.length)];
    } 
    else if (obj instanceof Object) 
    {
        return obj[randomElement(Object.keys[obj])];
    }
    return obj;
};

